import { useEffect, useRef } from 'react';
import menu_icon from '../../../resources/more-vertical.png'
import replace_icon from '../../../resources/replace.png'
import edit_icon from '../../../resources/edit 1.png'
import remove_icon from '../../../resources/remove.png'
import save_icon from '../../../resources/Vector.png'
import save_fill_icon from '../../../resources/save_fill.png'
import edit_meal_open from '../../../Utility/edit_meal_open';
import { del } from '../../../Services/api';

const TodayMealMenu = ({ i, date_index, meal, mealMenuIndex, setMealMenuIndex, userFavoriteMeal, setEditMeal, setReplaceUserMealId, setModalOpen, setDayModalOpenIndex }) => {
    const menuRef = useRef(null);

    useEffect(() => {
        // Close the menu when clicking outside
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMealMenuIndex(null);
            }
        };

        // Attach the event listener if the menu is open
        if (mealMenuIndex === i) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        // Cleanup the event listener on unmount or when the menu closes
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [mealMenuIndex, i, setMealMenuIndex]);

    async function removeMeal(user_meal_id) {
        await del("/api/meal-plan/remove-user-meal/" + user_meal_id)
        window.location.reload();
    }

    return (
        <div className='dashboard-today-meal-menu-all-div' ref={menuRef}>
            <div className='flex justify_center align_center cursor_pointer'
                onClick={() => mealMenuIndex === i ? setMealMenuIndex(null) : setMealMenuIndex(i)}>
                <img src={menu_icon} width={26} />
            </div>
            <div style={{ display: mealMenuIndex !== i && 'none' }} className='dashboard-today-meal-menu-list-div font_size_12 gray_scale_2'>
                <div className='cursor_pointer flex gap_8 align_center' onClick={() => {
                    setReplaceUserMealId(meal.user_meal_id); setModalOpen(true);
                    if (date_index) setDayModalOpenIndex(date_index);
                }}>
                    <img src={replace_icon} width={17} />
                    <p>Replace</p>
                </div>

                <div className='dashboard-today-meal-menu-list-divider'></div>

                <div className='cursor_pointer flex gap_8 align_center' onClick={() => edit_meal_open({ meal_id: meal.meal_id, setEditMeal: setEditMeal })}>
                    <img src={edit_icon} width={17} />
                    <p>Edit</p>
                </div>

                <div className='dashboard-today-meal-menu-list-divider'></div>

                <div className='cursor_pointer flex gap_10 align_center' onClick={() => userFavoriteMeal(meal.meal_id)} >
                    <img src={meal.favorite_id ? save_fill_icon : save_icon} height={17} />
                    <p>Favorite</p>
                </div>

                <div className='dashboard-today-meal-menu-list-divider'></div>

                <div className='cursor_pointer flex gap_8 align_center' onClick={() => removeMeal(meal.user_meal_id)}>
                    <img src={remove_icon} width={17} />
                    <p>Remove</p>
                </div>
            </div>
        </div>
    );
};

export default TodayMealMenu;
